var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoneLargeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 31,
    viewBox: "0 0 85 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 85,
    height: 31,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 85,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H20V11H65V2H83V12H74V19H83V29H65V20H20V29H2V19H11V12H2V2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H20V11H65V2H83V12H74V19H83V29H65V20H20V29H2V19H11V12H2V2Z",
    fill: "#AAD78C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H22V0H20V2ZM2 2V0H0V2H2ZM20 11H18V13H20V11ZM65 11V13H67V11H65ZM65 2V0H63V2H65ZM83 2H85V0H83V2ZM83 12V14H85V12H83ZM74 12V10H72V12H74ZM74 19H72V21H74V19ZM83 19H85V17H83V19ZM83 29V31H85V29H83ZM65 29H63V31H65V29ZM65 20H67V18H65V20ZM20 20V18H18V20H20ZM20 29V31H22V29H20ZM2 29H0V31H2V29ZM2 19V17H0V19H2ZM11 19V21H13V19H11ZM11 12H13V10H11V12ZM2 12H0V14H2V12ZM20 0H2V4H20V0ZM22 11V2H18V11H22ZM65 9H20V13H65V9ZM63 2V11H67V2H63ZM83 0H65V4H83V0ZM85 12V2H81V12H85ZM74 14H83V10H74V14ZM76 19V12H72V19H76ZM83 17H74V21H83V17ZM85 29V19H81V29H85ZM65 31H83V27H65V31ZM63 20V29H67V20H63ZM20 22H65V18H20V22ZM18 20V29H22V20H18ZM20 27H2V31H20V27ZM4 29V19H0V29H4ZM2 21H11V17H2V21ZM9.00005 12V19H13V12H9.00005ZM2 14H11V10H2V14ZM0 2V12H4V2H0Z",
    fill: "#219653",
    mask: "url(#path-1-outside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoneLargeGreen);
export default __webpack_public_path__ + "static/media/bone-large-green.225ac106b3b7dcc3399b0713462cbab9.svg";
export { ForwardRef as ReactComponent };